import React, { createContext } from "react";
import { usePrivileges } from "../hooks/usePrivileges";

const PrivilegesContext = createContext({
    contributor: undefined,
    supervisor: undefined,
    admin: undefined,
    canConfigure: undefined,
});

export const PrivilegesProvider = ({ children }) => {
    const { contributor, supervisor, admin, canConfigure } = usePrivileges();
   
    return (
        <PrivilegesContext.Provider value={{ contributor, supervisor, admin, canConfigure }}>
            {children}
        </PrivilegesContext.Provider>
    )
}

export default PrivilegesContext;